import { type FC } from 'react';
import { STATS } from '../content';
import { Container } from '../primitives';

export const StatsBand: FC = () => (
  <section className="bg-ink-900 py-14 sm:py-16">
    <Container>
      <dl className="grid grid-cols-2 gap-x-6 gap-y-10 lg:grid-cols-4">
        {STATS.map((stat) => (
          <div key={stat.label} className="border-l border-ink-600 pl-5">
            <dd className="font-mono text-3xl font-medium text-brand-400 sm:text-4xl">
              {stat.value}
            </dd>
            <dt className="mt-2 text-sm text-ink-300">{stat.label}</dt>
          </div>
        ))}
      </dl>
    </Container>
  </section>
);
